const STORAGE_KEY = 'zep_sso_auto_signin_at';
const RETRY_WINDOW_MS = 2 * 60 * 1000;

/**
 * 토큰 없는 교환 401 에서 auth 로 자동 이동해도 되는지 판정한다.
 * 같은 탭에서 2분 안에 이미 한 번 보냈으면 false — auth→교환→401→auth 루프 차단.
 * 첫 판정 시 타임스탬프를 남기므로 호출 자체가 1회 소비다.
 */
export function consumeSsoAutoSignin(now: number = Date.now()): boolean {
  try {
    const previous = Number(sessionStorage.getItem(STORAGE_KEY));
    if (previous && now - previous < RETRY_WINDOW_MS) return false;
    sessionStorage.setItem(STORAGE_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}

export function clearSsoAutoSignin(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage 접근 불가(프라이버시 모드 등)면 무시
  }
}
